<div class="map-container position-relative mt-8">
  <google-map *ngIf="data && isGoogleMapsLoaded" [center]="{ lat: data.lat, lng: data.lng }" [options]="mapOptions" [width]="'100%'" [height]="'200px'">
    <map-marker [options]="mapMarkerOptions" [position]="{ lat: data.lat, lng: data.lng }" />
    <button class="btn btn-sm bg-white position-absolute top-0 end-0 mt-4 me-4" type="button" mat-button color="primary" (click)="viewMap({ lat: data.lat, lng: data.lng })">
      Lihat Peta
    </button>
  </google-map>
  <div *ngIf="data && !isGoogleMapsLoaded" class="d-flex justify-content-center align-items-center" style="height: 200px;">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading map...</span>
    </div>
  </div>
  <div class="px-6 py-6">
    <app-skeleton-text [count]="1" [isLoading]="loading" type="text"
      ><h4 class="mb-2">{{ data?.label }}</h4></app-skeleton-text
    >
    <app-skeleton-text [count]="1" [isLoading]="loading" type="text">
      <span>{{ data?.description }}</span>
    </app-skeleton-text>
  </div>
</div>
